var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "",
    "data-name": "add",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8.50001C7.05229 8.50001 7.5 8.94773 7.5 9.50001L7.5 13.1569C7.5 13.433 7.72386 13.6569 8 13.6569V13.6569C8.27614 13.6569 8.5 13.433 8.5 13.1569L8.5 9.50001C8.5 8.94773 8.94772 8.50001 9.5 8.50001L13.1569 8.50001C13.433 8.50001 13.6569 8.27615 13.6569 8.00001V8.00001C13.6569 7.72387 13.433 7.50001 13.1569 7.50001L9.5 7.50001C8.94772 7.50001 8.5 7.0523 8.5 6.50001L8.5 2.84315C8.5 2.56701 8.27614 2.34315 8 2.34315V2.34315C7.72386 2.34315 7.5 2.56701 7.5 2.84315L7.5 6.50001C7.5 7.0523 7.05229 7.50001 6.5 7.50001L2.84314 7.50001C2.567 7.50001 2.34314 7.72387 2.34315 8.00001V8.00001C2.34315 8.27616 2.567 8.50001 2.84314 8.50001L6.5 8.50001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.29a9d324c79ba2fc264625768cce6373.svg";
export { ForwardRef as ReactComponent };